<template lang="pug">
  .wrapgal
    Gallery(:pics="images", :type="attrs.className")
</template>
<script>
import Gallery from '@/components/Gallery'
import axios from 'axios'

export default {
  props: {
    attrs: Object
  },
  data(){
    return {
      images: []
    }
  },
  components: {
    Gallery
  },
  methods: {
    fetchGallery(images){
      return new Promise((resolve, reject) => {
        const ids = []
        const base = 'https://copesano.acunaviera.com/wp-json/wp/v2/media/?include='
        images.map(image => {
          ids.push(image.id)
        })
        axios.get(`${base + ids.join(',')}`).then((result)=>{
          resolve(result.data)
        }).catch(err => reject(err))
      })
    },
    parseGallery(data){
      return new Promise((resolve, reject) => {
        const images = []
        data.map(data => {
          images.push(data.media_details.sizes)
        })
        resolve(images)
      }).catch(err => reject(err))
    }
  },
  computed: {
    digestedGallery() {
      const galleryInfo = this.fetchGallery(this.attrs.images).then(response => {
        this.parseGallery(response).then(images => {
          this.images = images
        }).catch(err => {
          return false
        })
      }).catch(err => {
        return false
      })
    },
  },
  mounted(){
    this.digestedGallery
  }
}
</script>
<style lang="scss" scoped>

</style>


